/// <amd-module name="Artifacts/Nuget/redux/Actions" />

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDefaultActionPayload,
  IDeleteActionPayload,
  IListActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
  IUpstreamOverrideActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum NugetActionTypes {
  Promote = "Artifacts/Nuget/Promote",
  PermanentDelete = "Artifacts/Nuget/PermanentDelete",
  Restore = "Artifacts/Nuget/Restore",
  UnlistOrRelist = "Artifacts/Nuget/UnlistOrRelist",
  Download = "Artifacts/Nuget/Download",
  SoftDelete = "Artifacts/Nuget/SoftDelete",
  SetUpstreamOverride = "Artifacts/Nuget/SetUpstreamOverride",
}

export const NugetActions = {
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IPromoteActionPayload>(NugetActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IDeleteActionPayload>(NugetActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IRestoreActionPayload>(NugetActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  changeListStatus: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    isListed: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IListActionPayload>(NugetActionTypes.UnlistOrRelist, {
        feed,
        versions,
        isListed,
        onSuccessCallback,
      }),
      versions.length,
    ),
  download: (feed: IFeed, versions: IPackageVersionIdentity[]) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IDefaultActionPayload>(NugetActionTypes.Download, {
        feed,
        versions,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<NugetActionTypes, IDeleteActionPayload>(NugetActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  setUpstreamOverride: (
    feed: IFeed,
    packageName: string,
    allowExternalVersions: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackedAction(
      createAction<NugetActionTypes, IUpstreamOverrideActionPayload>(
        NugetActionTypes.SetUpstreamOverride,
        { feed, packageName, allowExternalVersions, onSuccessCallback },
      ),
    ),
};

export type NugetActionsUnion = ActionsUnion<typeof NugetActions>;
